import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Header from '../../components/Dashboard/Header/Header';
import Sidebar from '../../components/Dashboard/Sidebar/Sidebar';
import Breadcrumbs from '../../components/Common/Breadcrumbs/Breadcrumbs';
import ProjectForm from './ProjectForm';
import styles from './CreateProject.module.css';

const EditProject = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const handleSave = () => {
    navigate('/projects');
  };

  const handleCancel = () => {
    navigate('/projects');
  };

  return (
    <div className={styles['create-project-container']}>
      {isSidebarOpen && <div className={styles['sidebar-overlay']} onClick={() => setIsSidebarOpen(false)}></div>}
      <Sidebar isOpen={isSidebarOpen} onClose={() => setIsSidebarOpen(false)} />
      <div className={styles['content-wrapper']}>
        <Header onMenuClick={() => setIsSidebarOpen(true)} />
        <main className={styles['main-content']}>
          <div className={styles['page-header']}>
            <div className={styles['header-title-section']}>
              <Breadcrumbs />
              <h1>Edit Project</h1>
              <p>Update project details, timelines, and operational settings.</p>
            </div>
          </div>
          <div className={styles['form-container']}>
            <ProjectForm project={{ id }} onSave={handleSave} onCancel={handleCancel} />
          </div>
        </main>
      </div>
    </div>
  );
};

export default EditProject;
